import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  token: "",
};

export type AppState = Readonly<typeof initialState>;

export const slice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    reset: (state) => {
      state.token = "";
    },
  },
});

export const { reset, setToken } = slice.actions;

export default slice.reducer;
